class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.open();
    this.disableInteraction();

    document.addEventListener('matchSmall', () => this.open());
    document.addEventListener('unmatchSmall', () => this.open());
  }

  onSummaryClick(event) {
    event.preventDefault();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {}

  disableInteraction() {
    this.summaryToggle.style.pointerEvents = 'none';
    this.summaryToggle.style.userSelect = 'none';
  }
}

customElements.define('footer-accordion', FooterAccordion);
